import React from "react";
import { ModalErrorMessageProps } from "./types";
import { ErrorModalOverlay, ErrorModalBox, ErrorModalClose, ErrorIcon, InlineErrorBox } from "./styles";

const ModalErrorMessage: React.FC<ModalErrorMessageProps> = ({ message, inline }) => {
  if (inline) {
    return (
      <InlineErrorBox>
        <ErrorIcon>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="12" fill="#F87171" />
            <path d="M12 7v5" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
            <circle cx="12" cy="16" r="1" fill="#fff" />
          </svg>
        </ErrorIcon>
        <span style={{ flex: 1 }}>{message}</span>
      </InlineErrorBox>
    );
  }
  return (
    <ErrorModalOverlay>
      <ErrorModalBox>
        <ErrorIcon>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="12" fill="#F87171" />
            <path d="M12 7v5" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
            <circle cx="12" cy="16" r="1" fill="#fff" />
          </svg>
        </ErrorIcon>
        <span style={{ flex: 1 }}>{message}</span>
      </ErrorModalBox>
    </ErrorModalOverlay>
  );
};

export default ModalErrorMessage;
